import { render } from "./detail-setting-vendors.vue?vue&type=template&id=4063c378"
import script from "./detail-setting-vendors.vue?vue&type=script&lang=js"
export * from "./detail-setting-vendors.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__